import React from 'react';
import { Input } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import HelpModal from '../Modals/helpModal';

const CompetencesCard = ({ statisticsData, onSearch, onNavigate, showModal }) => {
  const { t } = useTranslation();

  return (
    <div className="card" data-tut="reactour__competences">
      <div className="card-body">
        <div className="row">
          <div className="col-6 text-center" style={{ cursor: 'pointer' }} onClick={() => onNavigate('/competences')}>
            <br />
            <em className="icon-rocket fa-5x"></em>
          </div>
          <div className="col-6">
            <h3 className="mt-0">
              {t('competences.COMPETENCES')}
              &nbsp;
              <HelpModal
                purpose="competencesHelp"
                showModal={showModal}
                onToggle={() => onNavigate('toggleHelpModal', 'competencesHelp')}
              />
            </h3>
            <ul className="list-unstyled mb-0">
              <li className="mb-1">
                <div className="input-group with-focus">
                  <div className="input-group-prepend">
                    <span className="input-group-text bg-transparent border-right-0">
                      <em className="fa fa-search"></em>
                    </span>
                  </div>
                  <Input
                    type="text"
                    name="text"
                    id="competenceNameDashboard"
                    placeholder={t('competences.COMPETENCE_NAME_SEARCH')}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        onSearch(e.target.value);
                      }
                    }}
                  />
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="card-body bg-inverse" style={{ cursor: 'pointer' }} onClick={() => onNavigate('/competences')}>
        <div className="row text-center">
          <div className="col-4">
            <p className="m-0 h3">{statisticsData?.numCompetences}</p>
            <p className="m-0">{t('competences.ALL')}</p>
          </div>
          <div className="col-4"></div>
          <div className="col-4"></div>
        </div>
      </div>
    </div>
  );
};

export default CompetencesCard;
